import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import ServiceTerm from '@/components/popup/serviceTerms';
// import ConnectWallet from "@/components/popup/connectWallet";
import { localStorage } from '@/store/storage';
import { defaultAvatar } from '@/utils/resource';
import { mapState } from 'vuex';
import SigninApi from '@/api/modules/signin';
export default {
  components: {
    ServiceTerm: ServiceTerm
  },
  props: {
    isHeader: {
      type: String
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState(['chainid'])), {}, {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    account: function account() {
      var account = this.$store.state.account;
      //console.log('account===',account)
      if (account && account != null && account != 'null' && account != '') {
        account = this.$getAbbreviateAddress(this.$store.state.account);
        this.getReverse();
      } else {
        account = this.$t("header.connect");
        this.$store.commit('setPrimaryName', '');
      }
      return account;
    },
    primaryName: function primaryName() {
      return this.$store.state.primaryName;
    },
    headerImg: function headerImg() {
      return defaultAvatar();
    }
  }),
  watch: {
    chainid: {
      handler: function handler(to, from) {
        if (to || from) {
          this.getReverse();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    getReverse: function getReverse() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var primaryName;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$getSUID().getReverse(_this.$store.state.account, _this.$store.state.chainid);
            case 3:
              primaryName = _context.sent;
              _this.$store.commit('setPrimaryName', primaryName);
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              _this.$store.commit('setPrimaryName', '');
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    handleConnect: function handleConnect() {
      if (!this.$store.state.account || this.$store.state.account == 'null') {
        this.$store.commit('setShowConnectIsQuery', false);
        this.$store.commit('setShowConnect', false);
        this.$store.commit('setShowConnectIsQuery', true);
        this.$store.commit('setShowConnect', true);
      } else {
        this.$emit('handleShowUser');
      }
    }
  }
};